module.exports = __webpack_public_path__ + "media/img/vca/sponsors/ifly-e516b998a84e12cd596357723786e23f.png";